<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 row notes-dialog main-div">
 <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 px-0 text-left pb-3">
     <label class="design-header">{{
        data.title | translate
         }}</label>
 </div>
 <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 pb-3 text-right">
     <dxc-button applyclass="secondarybutton remove-button-shadow addbutton image-color" size="medium"
     margin="xxsmall" (onClick)="addFreeText()" mode="secondary"  [disabled]="disableaddbutton"
         label="{{ 'processClaims.anomalies.add' | translate }}" iconSrc="{{
           RESOURCE_SERVER_URL +
             '/assets/images/add-2.svg' 
         }}" iconPosition="after"></dxc-button>
 </div>
 <div class="card" *ngIf="freeTextItems.length > 0">
         <div class="scroll-class" [ngClass]="{'dialog-height':freeTextItems.length>1}">
             <ng-container *ngFor="let item of freeTextItems; let i = index">
                     <div class="row textarea-height">
                         <div class="col-xl-9 col-lg-9 col-md-9 col-sm-8 align-text-area">
                             <dxc-textarea margin="medium" class="text_class" [disabled]="item.summary.uuid!='' || !editclicked(i)"
                                 (onChange)="onEnteredFreeText($event,item)" [value]="item.summary.freeText">
                             </dxc-textarea>
                         </div>
                         <div [ngClass]="{'disable-row':item.summary.uuid!='' || editclicked(i) || finalScreenview}"
                             class="col-xl-1 col-lg-1 col-md-1 col-sm-2 text-right pr-0 align-images free-text-images">
                             <img class="action-IconDel" alt="Edit" [src]="editIcon" (click)="item.summary.uuid=='' && !editclicked(i) && !finalScreenview?onClickeditFreetext(i):''" />
                         </div>
                         <div [ngClass]="{'disable-row':disable}" class="col-xl-1 col-lg-1 col-md-1 col-sm-2 text-right pr-0 free-text-images">
                             <img class="action-IconDel" alt="Delete" (click)="!disable?openFileDialog(item, i):''" [src]="uploadIcon" />
                         </div>
                         <div  [ngClass]="{'disable-row':item.summary.uuid!=''}" class="col-xl-1 col-lg-1 col-md-1 col-sm-2 text-right pr-0 free-text-images">
                             <img class="action-IconDel" alt="Delete" [src]="deleteIcon" (click)="item.summary.uuid==''?deletePreDefined(i):''" />
                         </div>
                     </div>
                     <!-- <div class="row align-pdf">
                         <div class="col-12">
                             <ng-container *ngIf="item.summary.attachments != null">
                                 <div *ngIf="item.summary.attachments.length != 0">
                                     <span class="fileNameColor pb-2" (click)="viewPdf(item.summary.attachments[0].attachmentId)">{{item.summary.attachments[0].filename}}</span>
                                 </div>
                             </ng-container>
                         </div>
                     </div> -->
             </ng-container>
         </div>
 </div>
 <div class="thereIsNoData col-12 text-center" *ngIf="freeTextItems.length == 0">
     <p> {{ "processClaims.anomalies.noData" | translate }}</p>
 </div>
 <div class="col-12 text-center">
  <dxc-button class="remove-button-shadow" applyclass="remove-button-shadow addbutton" margin="xsmall"
         size="medium" (onClick)="saveNotes()"  [disabled]="disableaddbutton"
         label="{{'processClaims.anomalies.save' | translate }}"></dxc-button>
     <dxc-button applyclass="secondarybutton remove-button-shadow addbutton" margin="xsmall" size="medium"
         mode="secondary" (onClick)="onClose()"
         label="{{ 'processClaims.anomalies.cancel' | translate }}"></dxc-button>
 </div>
</div>

<!--File upload dialog-->
<dxc-dialog class="file-dialog" *ngIf="addFile" (onCloseClick)="openFileDialog(null, null)" [isCloseVisible]="false">
 <div class="dialog-content">
   <div class="row">
     <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
       <div class="file-input">
         <div class="row justify-content-center">
           <div>
             <label class="files-upload align-content">
              {{ 'processClaims.anomalies.uplodeFile' | translate }}
             </label>
           </div>
           <dxc-file-input [ngClass]="{'button-move': files === ''}" [value]="files" [showPreview]="true" [multiple]="false" accept=".pdf"
             (callbackFile)="onFileInput($event)">
           </dxc-file-input>
         </div>
       </div>
       <custom-button label="{{ 'processClaims.anomalies.submit' | translate }}" [disabled]="files.length === 0"
         (onClick)="uploadDocument(currentIndex)" margin="xxsmall"></custom-button>
       <custom-button class="secondarybutton remove-button-shadow " label="{{ 'processClaims.anomalies.cancel' | translate }}"
         mode="secondary" (onClick)="onCloseUpload()" margin="xxsmall"></custom-button>
     </div>
   </div>
 </div>
</dxc-dialog>
